jQuery('#ourServicesSlider').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    rows: 0,
    prevArrow: jQuery('.our-services-prev'),
    nextArrow: jQuery('.our-services-next'),
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 968,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 501,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});